import { connect } from "react-redux";
import ViewTagOrder from "./ViewTagOrder";
import { bindActionCreators } from "redux";
import { getToaTagOrders, approveTagOrder, getUserAnalytics } from "services/redux/fasTag/action";

const mapStateToProps = (state) => ({
  toaTagOrders: state.fastagPricingReducer.toaTagOrders,
  userAnalytics: state.fastagPricingReducer.userAnalytics,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToaTagOrders,
      approveTagOrder,
      getUserAnalytics,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewTagOrder);
